"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledTableRow = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../../framework/ty"));

var _templateObject;

var _default = {};
exports["default"] = _default;

var StyledTableRow = _styledComponents["default"].tr.withConfig({
  displayName: "TableRowstyles__StyledTableRow",
  componentId: "sc-184y2ak-0"
})(["&:nth-child(odd){", "}", ""], function (_ref) {
  var _table$type$type;

  var table = _ref.theme.table,
      type = _ref.type;
  return type === 'stripes' && (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["", "}"])), (_table$type$type = table.type[type]) === null || _table$type$type === void 0 ? void 0 : _table$type$type.rowBgColor);
}, function (_ref2) {
  var _table$type$type2;

  var table = _ref2.theme.table,
      type = _ref2.type;
  return "\n      ".concat((_table$type$type2 = table.type[type]) === null || _table$type$type2 === void 0 ? void 0 : _table$type$type2.row.css, "\n  ");
});

exports.StyledTableRow = StyledTableRow;